import { render, staticRenderFns } from "./admire.vue?vue&type=template&id=66dc36ed&scoped=true&"
import script from "./admire.vue?vue&type=script&lang=ts&"
export * from "./admire.vue?vue&type=script&lang=ts&"
import style0 from "./admire.vue?vue&type=style&index=0&id=66dc36ed&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc36ed",
  null
  
)

export default component.exports